import './udb.sdk.rsa.js'
declare const window: Window & { UDB: any }
export const encrypt = (value: string): string => window.UDB.SDK.rsa.RSAUtils.encryptedString(value)
